let isNodeEnvAvailable, isProduction, isTest;

try {
  isNodeEnvAvailable = process && process.env && process.env.NODE_ENV;
  isProduction = isNodeEnvAvailable && process.env.NODE_ENV === 'production';
  isTest = isNodeEnvAvailable && process.env.NODE_ENV === 'test';
} catch (e) {
  isNodeEnvAvailable = false;
  isProduction = false;
  isTest = false;
}

export { isNodeEnvAvailable, isProduction, isTest };
